import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { List } from 'immutable';

import history from 'helpers/history';

import { Button, Child, SidebarContent } from 'components';

import { setSidebar } from 'redux/reducers/app';
import { createOrder, getOrders } from 'redux/reducers/orders';
import { logout } from 'redux/reducers/user';

import { getActiveOrderId } from 'redux/selectors/app';
import { isAuthenticated } from 'redux/selectors/user';

import styles from './styles.scss';

@connect(
  state => ({
    authenticated: isAuthenticated(state),
    books: state.get('books', List()),
    orders: state.get('orders'),
    activeOrderId: getActiveOrderId(state),
    loading: state.getIn(['app', 'ui', 'loading_orders']) || state.get('books', List()).count() === 0,
  }),
  {
    getOrders,
    createOrder,
    setSidebar,
    logout,
  }
)
export default class MyOrders extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      creatingOrder: false,
      book: '',
      name: '',
      birthday: '',
    };
  }

  componentWillMount() {
    if (!this.state.creatingOrder && !this.props.authenticated) {
      this.props.setSidebar('login');
    } else {
      this.props.getOrders();
    }
  }

  componentDidUpdate() {
    const { activeOrderId, orders } = this.props;

    // Set latest book when not set yet
    if (!activeOrderId && orders && orders.count() > 0) {
      const orderId = orders.keySeq().first();
      history.replace(`/${orders.getIn([orderId, 'book'])}/${orderId}`);
      this.props.setSidebar('photos');
    }
  }

  creatingNewOrder = () => {
    this.setState({
      creatingOrder: true,
    });
  };

  cancelCreatingNewOrder = () => {
    this.setState({
      creatingOrder: false,
      book: '',
      name: '',
      birthday: '',
    });
  };

  newOrder = () => {
    const { book, name, birthday } = this.state;

    this.props.createOrder({
      book,
      name,
      birthday,
      redirect: true,
    });

    this.toPhotos();

    this.cancelCreatingNewOrder();
  };

  toLogin = e => {
    this.props.setSidebar('login');
  };

  toPhotos = e => {
    this.props.setSidebar('photos');
  };

  toChild = e => {
    this.props.setSidebar('child');
  };

  render() {
    const { books, orders, loading, authenticated } = this.props;
    const { book, name, birthday, creatingOrder } = this.state;
    const actions = [];

    let list = null;
    let content = null;
    let title = null;
    let anchorBottom = true;

    if (creatingOrder) {
      title = kroostApp.strings.openNewBook;

      actions.push(
        <Button key="cancel" secondary onClick={this.cancelCreatingNewOrder}>
          {kroostApp.strings.backButton}
        </Button>
      );
      anchorBottom = false;

      content = (
        <div>
          <Child
            book={book}
            name={name}
            birthday={birthday}
            asSidebar={false}
            onChange={(key, value) => {
              this.setState({
                [key]: value,
              });
            }}
          />

          <Button
            cta
            type="submit"
            className={styles.submit}
            disabled={(books.count() > 1 && !book) || !name || !birthday}
            onClick={this.newOrder}>
            Aan de slag
          </Button>
        </div>
      );
    }

    // Birthday: ({o.getIn(['child', 'birthday'])})
    if (!loading) {
      list = (
        <div className={styles.books}>
          {/*<Button className={styles.book} onClick={this.creatingNewOrder}>
					<span className={cx(styles.inner, styles.new)}>
						<IconPlus size={100} />
						<div>Nieuw boek</div>
					</span>
				</Button>*/}

          {orders
            ? orders
                .map((o, id) => {
                  const onClick = o.getIn(['child', 'name']) ? this.toPhotos : this.toChild;
                  const book = books.find(b => b.get('id') === o.get('book'));
                  return (
                    <Button className={styles.book} to={`/${o.get('book')}/${id}`} onClick={onClick} key={id}>
                      <span className={cx(styles.inner, styles.existing)}>
                        <div className={styles.name}>{book ? book.get('name') : ''}</div>
                        <div>{o.getIn(['child', 'name']) || '(Nieuw boek)'}</div>
                      </span>
                    </Button>
                  );
                })
                .toArray()
            : null}
        </div>
      );
    } else {
      list = kroostApp.strings.loading;
    }

    if (!creatingOrder) {
      if (authenticated) {
        title = kroostApp.strings.account;
        actions.push(
          <Button key="logout" secondary={true} onClick={this.props.logout}>
            {kroostApp.strings.logout}
          </Button>
        );
        content = list;
      }
    }

    return (
      <SidebarContent
        anchorActionsBottom={anchorBottom}
        title={title}
        actions={actions}
        className={!authenticated ? styles.notLoggedIn : null}>
        {content}
      </SidebarContent>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/my-orders/index.js